const HandleClick = async (
  carte_des_prix,
  layer_type,
  properties,
  lat = null,
  lng = null,

) => {
  let zoom = null;
  let layers_to_hide = [];
  let layers_to_display = [];
  if (carte_des_prix) {
    switch (layer_type) {
      case "regions":

        zoom = 9;
        layers_to_hide = [
          "regions",
          "regions_line",
          "communes",
          "communes_transparents",
          "communes_line",
          "plans-villa",
          "plans-appartement",
          "plans-villa_transparents",
          "plans-appartement_transparents",
          "plans-appartement_line",
          "plans-villa_line",
        ];

        layers_to_display = [
          "provinces",
          "provinces_transparent",
          "provinces_line",
        ];

        carte_des_prix.setFilter("provinces", [
          "all",

          ["==", "region", properties.region],
        ]);
        break;
      case "provinces":

        zoom = 12;
        layers_to_hide = [
          "regions",
          "regions_line",
          "provinces",
          "communes",
          "communes_transparents",
          "communes_line",
        ];
        layers_to_display = [
          "plans-villa",
          "plans-appartement",
          "plans-villa_transparents",
          "plans-appartement_transparents",
          "plans-appartement_line",
          "plans-villa_line",

          "provinces_transparent",
          "provinces_line",
        ];

        carte_des_prix.setFilter("plans-villa", [
          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_villa"], 0],
          ["==", ["get", "display_villa"], true],
          ["<", ["get", "nombre_transactions_appartement"], 6],
        ]);
        carte_des_prix.setFilter("plans-appartement", [
          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_appartement"], 0],
          ["==", ["get", "display_appartement"], true],
          [">", ["get", "nombre_transactions_appartement"], 5],
        ]);

        break;

      case "provinces_transparent":

        zoom = 12;
        layers_to_hide = [
          "regions",
          "regions_line",
          "provinces",
          "communes",
          "communes_transparents",
          "communes_line",
        ];
        layers_to_display = [
          "plans-villa",
          "plans-appartement",
          "plans-villa_transparents",
          "plans-appartement_transparents",
          "plans-appartement_line",
          "plans-villa_line",
          "provinces_transparent",
          "provinces_line",
        ];

        carte_des_prix.setFilter("plans-villa", [
          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_villa"], 0],
          ["==", ["get", "display_villa"], true],
          ["<", ["get", "nombre_transactions_appartement"], 6],
        ]);
        carte_des_prix.setFilter("plans-appartement", [
          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_appartement"], 0],
          ["==", ["get", "display_appartement"], true],
          [">", ["get", "nombre_transactions_appartement"], 5],]);

        break;

      case "communes":

        zoom = 12;
        layers_to_hide = [
          "regions",
          "regions_line",
          "provinces",
          "provinces_transparent",
          "communes",
          "communes_transparents",
          "communes_line",
        ];
        layers_to_display = [
          "plans-villa",
          "plans-appartement",
          "plans-villa_transparents",
          "plans-appartement_transparents",
          "plans-appartement_line",
          "plans-villa_line",
        ];
        carte_des_prix.setFilter("plans-villa", [
          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_villa"], 0],
          ["==", ["get", "display_villa"], true],
          ["<", ["get", "nombre_transactions_appartement"], 6],
        ]);
        carte_des_prix.setFilter("plans-appartement", [
          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_appartement"], 0],
          ["==", ["get", "display_appartement"], true],
          [">", ["get", "nombre_transactions_appartement"], 5],]);

        break;
      case "plans-villa":

        zoom = 14;
        layers_to_hide = [

          "regions",
          "regions_line",
          "provinces",
          "provinces_transparent",
          "communes",
          "communes_transparents",
          "communes_line",
        ];
        layers_to_display = [
          "plans-villa",
          "plans-appartement",
          "plans-villa_transparents",
          "plans-appartement_transparents",
          "plans-appartement_line",
          "plans-villa_line",
        ];

        carte_des_prix.setFilter("plans-villa", [

          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_villa"], 0],
          ["==", ["get", "display_villa"], true],
          ["<", ["get", "nombre_transactions_appartement"], 6],
        ]);
        carte_des_prix.setFilter("plans-appartement", [

          "all",

          ["==", "province", properties.province],
          ["!=", ["get", "prix_appartement"], 0],
          ["==", ["get", "display_appartement"], true],
          [">", ["get", "nombre_transactions_appartement"], 5],
        ]);

        break;

      case "plans-appartement":

        zoom = 14;
        layers_to_hide = [

          "regions",
          "regions_line",
          "provinces",
          "provinces_transparent",
          "communes",
          "communes_transparents",
          "communes_line",
        ];
        layers_to_display = [
          "plans-villa",
          "plans-appartement",
          "plans-villa_transparents",
          "plans-appartement_transparents",
          "plans-appartement_line",
          "plans-villa_line",
        ];

        carte_des_prix.setFilter("plans-villa", [

          "all",
          ["==", "province", properties.province],
          ["!=", ["get", "prix_villa"], 0],
          ["==", ["get", "display_villa"], true],
          ["<", ["get", "nombre_transactions_appartement"], 6],
        ]);
        carte_des_prix.setFilter("plans-appartement", [

          "all",

          ["==", "province", properties.province],
          ["!=", ["get", "prix_appartement"], 0],
          ["==", ["get", "display_appartement"], true],
          [">", ["get", "nombre_transactions_appartement"], 5],]);

        break;



      default:


        zoom = 14;
    }
    carte_des_prix.flyTo({
      center: [lng ? Math.min(lng, lat) : Math.min(properties.lat, properties.lng), lat ? Math.max(lng, lat) : Math.max(properties.lat, properties.lng)],
      zoom: zoom ? zoom : 11,
      speed: 3,
    });
    layers_to_hide.forEach((item) => {

      carte_des_prix.setLayoutProperty(item, "visibility", "none");
    });
    layers_to_display.forEach((item) => {


      carte_des_prix.setLayoutProperty(item, "visibility", "visible");


    });
  }
};

export default HandleClick;
